/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   #download-type-select[_ngcontent-%COMP%]{font-size:10px;width:100px}[_nghost-%COMP%]   button[_ngcontent-%COMP%]{font-size:10px}[_nghost-%COMP%]   .download-link[_ngcontent-%COMP%]{color:#fff}[_nghost-%COMP%]   .download-link[_ngcontent-%COMP%]:visited{color:#fff}[_nghost-%COMP%]   .skinny-button[_ngcontent-%COMP%]{line-height:normal;padding:5px}"];
export { styles as styles };
